import { useContext } from 'react';
import { DefaultTokenConfig } from '../components/editor/MarkdownEditorContext';
import { ChatTaskContext } from '../contexts/ChatTaskContext';
import { BoldToken, ItalicToken, BulletListToken, MathToken } from '@scale/shared/types/config';

export function useMarkdownSyntaxOptions(): DefaultTokenConfig {
  const taskContext = useContext(ChatTaskContext);
  const markdownSyntaxConfig = taskContext?.markdownSyntaxConfig;
  return {
    boldToken: markdownSyntaxConfig?.boldToken ?? BoldToken.ASTERISK,
    italicToken: markdownSyntaxConfig?.italicToken ?? ItalicToken.ASTERISK,
    bulletListToken: markdownSyntaxConfig?.bulletListToken ?? BulletListToken.ASTERISK,
    mathToken: markdownSyntaxConfig?.mathToken ?? MathToken.DOLLARS,
  };
}
